const langtrans={
      dhtzzz:["导航跳转有","en_translated"],
      fhsy:["返回首页","Back to homepage"],
      gl:["管理","management"],
      dddfab:["等待方案报价案件","Cases waiting for quotation"],
      dddsqz:["等待授权中","Waiting for authorization"],
      jyzzaj:["救援中案件管理","Management of cases in progress"],
      ywcaj:["已完成案件","Cases completed"],
      bjjjyg:["报价已关闭案件","Cases with quotation closed"],
      ajgl:["案件管理","Case management"],
      ywcjya:["已完成救援案件列表","List of completed Assistance cases"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/Caseindex.vue.trans.js